var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PasswordResetSteps',{attrs:{"steps":_vm.steps,"image":"img/app-animation.gif"}})
}
var staticRenderFns = []

export { render, staticRenderFns }